import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { Button, Offcanvas } from 'react-bootstrap';
import Emitter from '../../utils/emitter';
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import MobileNavItem from './MobileNavItem';
const MobileNav = () => {
    const [logo, setLogo] = useState(null);
    const [navInfo, setNavInfo] = useState(null);
    const [show, setShow] = useState(false);
    useEffect(() => {
        client
            .query({
                query: queries.mobileNavInfo,
            })
            .then((response) => {
                const navDoc = response.data.allNavbar2s.edges[0].node;
                const logoInfo = response.data.allNavbars.edges[0].node;
                setLogo(logoInfo);
                setNavInfo(navDoc?.nav_link);



            })
            .catch((error) => {
                console.error(error);
            });
    });
    const toggleDropDown = (area,slNo) => {
        setShow(false)
      
        if (area == "Innovation Fellow" || area == "Investment Committee" || area == "Venture Fund" || area == "Cohorts" || area == "View Programs") {
            sessionStorage.setItem("InnovationSection", area);
            Emitter.emit("MOVE_INNOVATION_SECTION", area);
        }
    }
    return (
        <div className="mobile-nav-container">
            <div className=" p-2 d-flex justify-content-between align-items-center" >
                <div><img src={logo?.pirmary_logo?.url} alt="" className="img-fluid "></img></div>
                <div><img src={logo?.secondary_logo?.url} alt="" className="img-fluid "></img></div>

                <span onClick={() => setShow(true)} className="toggleBtnBox ">
                    <div className='navLine mobile-toggle'></div>
                    <div className='navLine mobile-toggle'></div>
                    <div className='navLine mobile-toggle'></div>
                </span>
            </div>

            <Offcanvas show={show} onHide={() => setShow(false)} placement={'end'}>
                <div className="offcanvas-header  d-flex justify-content-end">
                    <button
                        onClick={() => setShow(false)}
                        type="button"
                        className=" border btn py-1" >
                        Close
                        <FontAwesomeIcon
                            className=" ms-1"
                            icon={faTimes}
                        />
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="accordion accordion-flush" id="accordionFlushExample">
                        {navInfo?.map((navInfo, index) => <MobileNavItem toggleDropDown={toggleDropDown} navInfo={navInfo} key={index + 1} slNo={index + 1} setShow={setShow} />)}


                    </div>
                </div>
            </Offcanvas>

            {/* <div className="offcanvas  offcanvas-end" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                <div className="offcanvas-header  d-flex justify-content-end">

                    <button
                        type="button"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        className=" border btn py-1" >Close
                        <FontAwesomeIcon
                            className=" ms-1"
                            icon={faTimes}
                        />
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="accordion accordion-flush" id="accordionFlushExample">
                        {navInfo?.map((navInfo, index) => <MobileNavItem navInfo={navInfo} key={index + 1} slNo={index + 1} />)}


                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default MobileNav;